// src/services/scannerService.ts

import api from "./api";

// Fetch scanner results
export async function getScannerResults() {
  try {
    const response = await api.get("/scanner");
    return response.data;
  } catch (error) {
    console.error("Error fetching scanner results", error);
    return [];
  }
}

export const scanSwingStocks = async () => {
  try {
    const response = await api.get("/scanner/scan/swing-stocks");
    const results = response.data;

    try {
        // Fetch fresh "Previous Close" prices to fix stale data issues
        const freshPricesRes = await api.get("/scanner/fresh-prices");
        const freshPrices = freshPricesRes.data;

        // Merge fresh prices into results
        return results.map((item: any) => {
            const fresh = freshPrices[item.instrument_token];
            if (fresh) {
                return { ...item, prevClose: fresh.prevClose };
            }
            return item;
        });
    } catch (err) {
        console.warn("Failed to fetch fresh prices, using DB values", err);
        return results;
    }
  } catch (error) {
    console.error("Error fetching swing-stocks scanner results", error);
  }
};
export const scanScreenerStocks = async () => {
  try {
    const response = await api.get("/scanner/scan/screener");
    return response.data;
  } catch (error) {
    console.error("Error fetching screener scanner results", error);
  }
};

// Start a trade for a selected stock
export async function startTrade(symbol: string) {
  try {
    const response = await api.post("/orders", { symbol });
    return response.data;
  } catch (error) {
    console.error("Error starting trade", error);
  }
}

export const syncStocks = async () => {
  try {
    const response = await api.post("/scanner/sync-stocks");
    return response.data;
  } catch (error) {
    console.error("Error syncing stocks", error);
    throw error;
  }
};

export async function fetchSwingScannerResults() {
  try {
    console.log('🔄 [Frontend] Fetching scanner results...');
    const response = await api.get("/scanner/results/swing-stocks");
    return response.data;
  } catch (error) {
    console.error("Error fetching scanner results:", error);
    throw error;
  }
}
export async function fetchScreenerScannerResults() {
  try {
    const response = await api.get("/scanner/results/screener");
    return response.data;
  } catch (error) {
    console.error("Error fetching scanner results:", error);
    throw error;
  }
}
 
export async function fetchIntradayResults(date?: string) {
  try {
    const url = date ? `/intraday-stocks/results?date=${date}` : `/intraday-stocks/results`;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching intraday results:", error);
    throw error;
  }
}
 
export async function scanIntradayStocks() {
  try {
    const response = await api.post("/intraday-stocks/trigger");
    return response.data;
  } catch (error) {
    console.error("Error triggering intraday scan:", error);
    throw error;
  }
}
export async function calcOrh() {
  try {
    const response = await api.post("/intraday-stocks/calc-orh");
    return response.data;
  } catch (error) {
    console.error("Error calculating ORH:", error);
    throw error;
  }
}

export async function updateVwap() {
  try {
    const response = await api.post("/intraday-stocks/update-vwap");
    return response.data;
  } catch (error) {
    console.error("Error updating VWAP:", error);
    throw error;
  }
}

export async function runIntradayStrategies() {
  try {
    const response = await api.post("/intraday-stocks/run-strategies");
    return response.data;
  } catch (error) {
    console.error("Error running strategies:", error);
    throw error;
  }
}

export async function getIntradaySettings() {
  try {
    const response = await api.get("/intraday-stocks/settings");
    return response.data;
  } catch (error) {
    console.error("Error fetching settings:", error);
    return {};
  }
}

export async function updateIntradaySettings(key: string, value: any) {
  try {
    const response = await api.post("/intraday-stocks/settings", { key, value });
    return response.data;
  } catch (error) {
    console.error("Error updating settings:", error);
    throw error;
  }
}

export async function submitIntradayTrade(data: any) {
  try {
    const response = await api.post("/intraday-stocks/trade", data);
    return response.data;
  } catch (error) {
    console.error("Error submitting intraday trade:", error);
    throw error;
  }
}
